<template>
  <MainLayout hide-route-header>
    <div class="max-w-3xl mx-auto">
      <Card>
        <CardHeader>
          <CardTitle v-if="isLoading">
            <div class="spinner"></div>
          </CardTitle>
          <CardTitle v-else> Link your Meta account </CardTitle>
        </CardHeader>
        <CardContent>
          <p class="my-4">
            In order for us to manage ads on your behalf, we need access to your Facebook Page and Meta Ad Account.
            Please click the link below and go through the connection process.
          </p>

          <div class="flex justify-center flex-col items-center gap-3 mt-8">
            <a
              target="_blank"
              href="https://app.leadsie.com/connect/humaniz/manage"
              class="mb-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <vue-feather type="external-link" class="mr-2" />
              Connect account
            </a>
            <a
              target="_blank"
              href="https://calendly.com/todd-h3/humaniz-metaonboarding"
              class="rounded-md cursor-pointer group flex items-center px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
            >
              Need help? Schedule a call
            </a>
            <button
              class="rounded-md cursor-pointer group flex items-center px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
              @click="completeAccess"
            >
              I've already completed this
            </button>
          </div>
        </CardContent>
      </Card>
    </div>
  </MainLayout>
</template>

<script setup lang="ts">
import MainLayout from '@/components/layouts/MainLayout/index.vue';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { onMounted, ref } from 'vue';
import { Api } from '@/api';
//@ts-ignore
import useMetaCoordinator from './useMetaCoordinator';
import type { FacebookAdConfig } from '@/api/quickstart';
import { useRouter } from 'vue-router';
import { toast } from 'vue-sonner';

const { enforcePageAccess } = useMetaCoordinator();
const router = useRouter();

const facebookAdConfig = ref<FacebookAdConfig | null>(null);
const isLoading = ref(true);

const completeAccess = async () => {
  const errors = [];

  if (facebookAdConfig.value) {
    facebookAdConfig.value.status = 'pending';
    const result = await Api.Quickstart.updateFacebookAdConfig({
      facebookAdConfig: facebookAdConfig.value,
    });
    if (result.status === 'error') errors.push(result.message || 'Unknown network error.');
  } else {
    if (!facebookAdConfig.value) errors.push("Team's facebook advertising configuration was not found.");
  }

  if (errors.length > 0) {
    toast.error('Failed to update', {
      action: { label: 'Dismiss' },
      description: errors.join(', '),
    });
  } else {
    router.push('/');
    toast.success('Updated successfully', {
      action: { label: 'Dismiss' },
      description: 'Congrats, you have linked your account!',
    });
  }
};

onMounted(async () => {
  const facebookAdConfigResponse = await Api.Quickstart.getFacebookAdConfig();
  isLoading.value = false;
  await enforcePageAccess(facebookAdConfigResponse);
  if (facebookAdConfigResponse?.record) facebookAdConfig.value = facebookAdConfigResponse.record;
});
</script>
